import {MenuInterface} from "../model/MenuInterface";

const getLink = (subMenu: MenuInterface): string => {
    switch (subMenu.route) {
        case '/board':
            return `/board/${subMenu.menuId}`;
        case '/static':
            return `/static/${subMenu.menuId}`;
        case null:
            return '/';
        default:
            return subMenu.route;
    }
}

export { getLink };
